/**
 * Ready-made email texts for the super admin (docs/email-plan.md). Every email
 * is Hebrew first, English below, whatever language the site is shown in, so
 * the texts come from both translation files (pass i18n.getFixedT('he') / ('en')).
 * The super admin can change everything before pressing Send.
 */
export type ListingEmailKind = 'approved' | 'rejected' | 'message';

type Translate = (key: string, options?: Record<string, unknown>) => string;

export interface EmailDraft {
  subject: string;
  message: string;
}

export function emailDraft(
  kind: ListingEmailKind,
  listing: { nameHe?: string; nameEn?: string },
  reason: string,
  tHe: Translate,
  tEn: Translate
): EmailDraft {
  const nameHe = (listing.nameHe || listing.nameEn || '').trim();
  const nameEn = (listing.nameEn || listing.nameHe || '').trim();
  const trimmedReason = reason.trim();
  const bodyKey = kind === 'rejected' && !trimmedReason ? 'bodyNoReason' : 'body';
  const part = (t: Translate, name: string) => ({
    subject: t(`email.draft.${kind}.subject`, { name }),
    body: t(`email.draft.${kind}.${bodyKey}`, { name, reason: trimmedReason }),
  });
  const he = part(tHe, nameHe);
  const en = part(tEn, nameEn);
  return { subject: `${he.subject} | ${en.subject}`, message: `${he.body}\n\n${en.body}` };
}
